import React from "react";
import { Link } from "react-router-dom";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="not-found-state">
          <span>Oops</span>
          <h1>Something went wrong</h1>
          <p>Your cart is safe. Return home and try that again.</p>
          <Link className="button button--primary" to="/">Return home</Link>
        </main>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
